export default "__VITE_ASSET__J1B_A1tn__"